export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8794.1dff5398.jpg";